import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from '../Button';
import { ModalHeader } from '../ModalHeader';
import { AlertMessage } from '../AlertMessage';
import { formatClassName } from '../../utils';
import { i18n } from '../../i18n/translate';

export class GenericModal extends React.Component {
  static propTypes = {
    bsSize: PropTypes.string,
    canClose: PropTypes.bool,
    children: PropTypes.node,
    container: PropTypes.node,
    footerCloseButton: PropTypes.oneOfType([
      PropTypes.shape({
        attributes: PropTypes.object,
        variant: PropTypes.string,
        bsStyle: PropTypes.string,
        id: PropTypes.string,
        isTurnedOn: PropTypes.bool,
        text: PropTypes.string,
      }),
      PropTypes.bool,
    ]),
    id: PropTypes.string,
    message: PropTypes.string,
    messageType: PropTypes.oneOf(['danger', 'info', 'success', 'warning']),
    modalClass: PropTypes.string,
    onClose: PropTypes.func,
    saveButtonConfig: PropTypes.shape({
      attributes: PropTypes.object,
      disabled: PropTypes.bool,
      id: PropTypes.string,
      saveAction: PropTypes.func,
      saveStyle: PropTypes.string,
      saveText: PropTypes.string,
    }),
    show: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
    showAlert: PropTypes.bool,
    stickyFooter: PropTypes.bool,
    title: PropTypes.string,
  };

  static defaultProps = {
    show: true,
    showAlert: false,
    size: 'medium',
    stickyFooter: false,
  };

  renderFooter() {
    const { footerCloseButton, saveButtonConfig, stickyFooter } = this.props;
    const hasButtons = (footerCloseButton && footerCloseButton.isTurnedOn) || saveButtonConfig;
    if (hasButtons) {
      return (
        <Modal.Footer className={stickyFooter && 'sticky-footer'}>
          {footerCloseButton.isTurnedOn && (
            <Button
              variant={footerCloseButton.variant}
              id={footerCloseButton.id || 'generic-modal-cancel-button'}
              style={footerCloseButton.bsStyle || 'secondary'}
              onClick={this.props.onClose}
              {...footerCloseButton?.attributes}
            >
              {footerCloseButton.text || i18n.t('Cancel')}
            </Button>
          )}
          {saveButtonConfig && (
            <Button
              disabled={saveButtonConfig.disabled}
              variant={saveButtonConfig.saveStyle}
              id={saveButtonConfig.id || 'generic-modal-save-button'}
              onClick={saveButtonConfig.saveAction}
              style={saveButtonConfig.saveStyle || 'primary'}
              {...saveButtonConfig.attributes}
            >
              {saveButtonConfig.saveText || i18n.t('Save')}
            </Button>
          )}
        </Modal.Footer>
      );
    }
  }

  getModalClasses = () => {
    const { modalClass, size, stickyFooter } = this.props;
    return formatClassName([`${modalClass}`, `modal-size-${size}`, { 'sticky-footer': stickyFooter }]);
  };

  render() {
    const { bsSize, canClose, container, id, message, messageType, onClose, show, showAlert, title } = this.props;
    const modalClassName = this.getModalClasses();
    return (
      <Modal
        animation={false}
        backdrop={canClose ? true : 'static'}
        size={bsSize}
        className={modalClassName}
        container={container}
        id={id}
        keyboard={canClose}
        onHide={onClose}
        show={show}
      >
        <ModalHeader onCancel={onClose} canClickOff={canClose} title={title} />
        <AlertMessage message={message} messageType={messageType} visible={showAlert} />
        <Modal.Body>{this.props.children}</Modal.Body>
        {this.renderFooter()}
      </Modal>
    );
  }
}
